// test2878
(2878 && 0);
